/** Stable row id for draft multi-option fields (Add Question modal). */
export const createDraftOptionRow = (value = '') => ({
  id: `opt_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`,
  value,
});
